import {ActionType} from "typesafe-actions";
import * as actions from "./actions";
import {PayloadAction} from "typesafe-actions/dist/type-helpers";

export interface IErrorState {
    errors: IAggregatedError[];
    metrics: IAggregatedMetric[];
    [key: string]: any;
}

export type ErrorActions = ActionType<typeof actions> | PayloadAction<string, any>;

export interface IAggregatedError {
    logLevel: LogLevel;
    category: string;
    message: string;
    stack?: string;
    data?: object;
}

export interface IAggregatedMetric {
    logLevel: LogLevel;
    category: string;
    action: string;
    start: number;
    end: number;
    duration: number;
    data?: object;
}

export enum LogLevel {
    Trace = 0,
    Debug = 1,
    Info = 2,
    Warn = 3,
    Error = 4,
    Fatal = 5,
    Off = 6
}

export interface IErrorMessage {
    logLevel?: LogLevel;
    category: string;
    message: string;
    error?: Error;
    data?: object;
}

export interface IPerformanceMessage {
    category: string;
    action: string;
    start: number;
    end: number;
}